/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoNftRepairLogListNftRepairLogData model module.
 * @module model/LogControllerDtoNftRepairLogListNftRepairLogData
 * @version 1.0
 */
class LogControllerDtoNftRepairLogListNftRepairLogData {
    /**
     * Constructs a new <code>LogControllerDtoNftRepairLogListNftRepairLogData</code>.
     * @alias module:model/LogControllerDtoNftRepairLogListNftRepairLogData
     */
    constructor() { 
        
        LogControllerDtoNftRepairLogListNftRepairLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoNftRepairLogListNftRepairLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoNftRepairLogListNftRepairLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoNftRepairLogListNftRepairLogData} The populated <code>LogControllerDtoNftRepairLogListNftRepairLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoNftRepairLogListNftRepairLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('beforeCondition')) {
                obj['beforeCondition'] = ApiClient.convertToType(data['beforeCondition'], 'Number');
            }
            if (data.hasOwnProperty('afterCondition')) {
                obj['afterCondition'] = ApiClient.convertToType(data['afterCondition'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('durability')) {
                obj['durability'] = ApiClient.convertToType(data['durability'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoNftRepairLogListNftRepairLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoNftRepairLogListNftRepairLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} beforeCondition
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['beforeCondition'] = undefined;

/**
 * @member {Number} afterCondition
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['afterCondition'] = undefined;

/**
 * @member {Number} level
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['level'] = undefined;

/**
 * @member {Number} durability
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['durability'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} cost
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['cost'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoNftRepairLogListNftRepairLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoNftRepairLogListNftRepairLogData;

